/* eslint-disable import/no-named-as-default */
import Table, { Icon } from "./Table";

export { Icon };
export default Table;
